import Vue from 'vue'
import Router from 'vue-router'

// Routes
import user_routes from "./routes/users"
import tenant_category_routes from "./routes/tenant_categories"
import tenant_space_routes from "./routes/tenant_spaces"
import wayfinder_tenant_routes from "./routes/wayfinder_tenants"
import tenant_routes from "./routes/tenants"
import tenant_data_entrance_routes from "./routes/tenant_data_entrance"
import tenant_data_main from "./routes/tenant_data_main"
import tenant_data_history from "./routes/tenant_data_history"
import logs_routes from "./routes/logs"
import transactions_routes from "./routes/transactions"

// Containers
const TheContainer = () => import('../containers/TheContainer')

// Views
const Profile = () => import('../components/Profile/Profile')

// Pages
const Error403 = () => import('../views/pages/Page403');
const Error404 = () => import('../views/pages/Page404');
const Login = () => import('../views/pages/Login.vue');

Vue.use(Router)

const route_error_403 = {
  path: '/error/403',
  name: 'error.403',
  component: Error403,
};

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      redirect: '/tenants',
      component: TheContainer,
      meta: {'auth': true},
      children: [
        {
          path: 'profile',
          name: 'profile',
          component: Profile,
        },
        user_routes,
        tenant_category_routes,
        tenant_space_routes,
        wayfinder_tenant_routes,
        tenant_routes,
        tenant_data_entrance_routes,
        tenant_data_main,
        tenant_data_history,
        logs_routes,
        transactions_routes,
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {'guest': true},
    },
    {
      path: '/*',
      name: 'error_404',
      component: Error404,
    },
  ]
});

router.beforeEach((to, from, next) => {
  // Unauthenticated user redirect to login
  if (to.matched.some(m => m.meta.auth === true) && !router.app.$user.check()) {
    return router.push({name: 'login'});
  }

  // Authenticated user redirect to tenants
  if (to.matched.some(m => m.meta.guest === true) && router.app.$user.check()) {
    return router.push({name: 'tenants'});
  }

  // Get all permissions of the route and all its parents
  let permissions = [];
  to.matched.forEach((route) => {
    if (route.meta.permissions) {
      permissions = permissions.concat(Array.isArray(route.meta.permissions) ? route.meta.permissions : [route.meta.permissions]);
    }
  });

  // Check permissions and redirect to 403 if authenticated user doesn't have permissions to view the page
  if (!router.app.$user.canAll(permissions)) {
    router.addRoutes([route_error_403]);
    return router.replace({name: 'error.403'});
  }

  return next();
});

export default router;
